import {
  Swiper,
  Navigation,
  Pagination,
  Keyboard,
  Autoplay,
  Mousewheel,
  // Scrollbar,
} from 'swiper';

import AOS from 'aos';

Swiper.use([Navigation, Pagination, Autoplay, Keyboard, Mousewheel]);

const navigation = (target) => {
  return {
    nextEl: `.${target}-swiper__button--next`,
    prevEl: `.${target}-swiper__button--prev`,
  };
};

$(window).on('load', function () {
  swipers();
});

const swipers = () => {
  exclusiveSwiper();
  sliderImages();
  stepsWrapperSwiper();
  mediaImages();
  imageSwiper();
  floorplanSwiper();
  objectSwiper();
  reviewSwiper();
  AOS.refresh();
};

const exclusiveSwiper = () => {
  const swiper = new Swiper('.module--exclusive__swiper', {
    direction: 'horizontal',
    spaceBetween: 40,
    allowTouchMove: true,
    keyboard: true,
    speed: 500,
    loop: true,
    observer: true,
    observeParents: true,
    slidesPerView: 1,
    autoHeight: true,
    navigation: {
      nextEl: `.module--exclusive__swiper__progress__down`,
      prevEl: `.module--exclusive__swiper__progress__up`,
    },
    pagination: {
      el: '.module--exclusive__swiper__progress .swiper-progress',
      type: 'fraction',
      formatFractionCurrent: function (number) {
        return ('0' + number).slice(-2);
      },
      formatFractionTotal: function (number) {
        return ('0' + number).slice(-2);
      },
    },
    breakpoints: {
      992: {
        allowTouchMove: false,
        direction: 'vertical',
        speed: 1500,
        mousewheel: {
          enabled: true,
          releaseOnEdges: false,
        },
      },
    },
  });

  // Voeg een event listener toe om de status van releaseOnEdges te wijzigen
  swiper.on('slideChange', () => {
    const isLastSlide = swiper.activeIndex === swiper.slides.length - 1;
    swiper.params.mousewheel.releaseOnEdges = isLastSlide;
  });

  return swiper;
};

const reviewSwiper = () => {
  return new Swiper('.review-slide__swiper', {
    observer: true,
    observeParents: true,
    loop: false,
    slidesPerView: 1,
    autoHeight: true,
    spaceBetween: 40,
    navigation: navigation('review-slide__swiper'),
    breakpoints: {
      1200: {
        autoHeight: false,
        slidesPerView: 2.2,
      },
      768: {
        slidesPerView: 2,
        autoHeight: false,
      },
      0: {
        slidesPerView: 1,
        autoHeight: true,
      },
    },
  });
};

const objectSwiper = () => {
  return new Swiper('.objects__swiper', {
    loop: false,
    slidesPerView: 1.1,
    spaceBetween: 28,
    centeredSlides: false,
    navigation: navigation('objects__swiper'),
    breakpoints: {
      992: {
        slidesPerView: 2.3,
        spaceBetween: 35,
      },
      0: {
        slidesPerView: 1.1,
        spaceBetween: 28,
      },
    },
  });
};

const floorplanSwiper = () => {
  return new Swiper('.floorplan-swiper', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 1,
    navigation: navigation('floorplan-swiper'),
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    // autoplay: {
    //     delay: 5000,
    // },
  });
};

const imageSwiper = () => {
  return new Swiper('.image-swiper', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 1,
    navigation: navigation('image-swiper'),
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    // autoplay: {
    //     delay: 5000,
    // },
  });
};

const mediaImages = () => {
  return new Swiper('.rw-page-header-single__swiper', {
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 0,
    navigation: navigation('rw-page-header-single__swiper'),
    breakpoints: {
      992: {
        slidesPerView: 'auto',
      },
      0: {
        slidesPerView: 'auto',
      },
    },
  });
};

const sliderImages = () => {
  return new Swiper('.slider__images', {
    loop: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 0,
    navigation: navigation('slider__images'),
    breakpoints: {
      992: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 'auto',
      },
    },
  });
};

const stepsWrapperSwiper = () => {
  return new Swiper('.steps__wrapper__swiper', {
    observer: true,
    observeParents: true,
    loop: false,
    slidesPerView: 1,
    autoHeight: true,
    spaceBetween: 40,
    navigation: navigation('steps__wrapper__swiper'),
    breakpoints: {
      1200: {
        autoHeight: false,
        slidesPerView: 2.3,
      },
      768: {
        slidesPerView: 2,
        autoHeight: false,
      },
      0: {
        slidesPerView: 1,
        autoHeight: true,
      },
    },
  });
};

// only if 
let hasReloaded = false; // Zorgt ervoor dat de pagina maar één keer wordt herladen
let lastWidth = window.innerWidth; // Bewaart de breedte van het venster bij de vorige resize

// only if .module--exclusive__swiper exists
if(document.querySelector('.module--exclusive__swiper')) {
  window.addEventListener('resize', () => {
      const currentWidth = window.innerWidth;

      if (!hasReloaded && (
          (lastWidth > 991.89 && currentWidth <= 991.89) ||
          (lastWidth <= 991.89 && currentWidth > 991.89)
      )) {
          hasReloaded = true; // Markeer dat we de pagina hebben herladen
          location.reload(); // Herlaad de pagina
      }

      lastWidth = currentWidth; // Werk de breedte bij voor de volgende resize
  });
}
